import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-general-modal',
  templateUrl: './general-modal.component.html',
  styleUrls: ['./general-modal.component.scss']
})
export class GeneralModalComponent implements OnInit {
	msg: string = "";
	buttons: any = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<GeneralModalComponent>,
	) {
		if (data) {
			this.msg = data.msg;
			this.buttons = data.buttons;
			this.dialogRef.disableClose = true;
		}
	}

	ngOnInit() {}

	closeModal() {
		this.dialogRef.close();
	}
}
